interface LengthOfTimeEntry {
  years?: string
  months?: string
}

export const buildLengthOfTimeEntry = (years : string | undefined, months: string | undefined) : LengthOfTimeEntry => {
  const answer : LengthOfTimeEntry = {}
  if (years !== undefined) {
    answer.years = years
  }
  if (months !== undefined) {
    answer.months = months
  }
  return answer
}

export default LengthOfTimeEntry
